import { Button, Grid, Stack } from '@mui/material';
import { CustomContainer } from '../../components/CustomContainer/CustomContainer';
import colors from '../../colors/colors';
import { GoHeart } from "react-icons/go";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './ThankYou.scss';


export default function ThankYou() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        const storedId = localStorage.getItem("rdv_id");

        if (!storedId || storedId !== id) {
            navigate("/");
        } else {
            setIsValid(true);
        }
    }, [id, navigate]);

    if (!isValid) return null;

    return (
        <div style={{ overflowX: "hidden" }}>
            <div className='bg-merci'>
                <CustomContainer>
                    <Stack gap={2} alignItems={"center"} width={"100%"} pt={{ xs: 15, md: 20 }} pb={{ md: 26, xs: 4 }}>
                        <GoHeart color='white' size={100} />
                        <h2 className='h1-white text-center'>Merci, nous avons bien reçu votre <span className="bg-pink">demande</span> !</h2>
                    </Stack>
                </CustomContainer>
            </div>
            <CustomContainer>
                <Stack px={{ md: 18, xs: 0 }} mt={{ md: -20, xs: 4 }}>
                    <Grid container className='box-flottant' px={{ md: 12, xs: 0 }} py={{ md: 5, xs: 2 }}>
                        <Grid item md={12} xs={12} px={4} mb={4}>
                            <p className='century-bold text-center' style={{ color: colors.dark, fontSize: 24 }}>
                                Julia Assurance c’est :
                            </p>
                        </Grid>
                        <Grid item md={4} xs={12} px={4}>
                            <Stack className='century-bold' fontSize={40} textAlign={'center'} color={colors.green} pb="16px">+20000</Stack>
                            <Stack fontSize={18} textAlign={'center'} color={colors.dark}>Clients satisfaits</Stack>
                        </Grid>
                        <Grid item md={4} xs={12} px={4}>
                            <Stack className='century-bold' fontSize={40} textAlign={'center'} color={colors.teal} pb="16px">4.8/5</Stack>
                            <Stack fontSize={18} textAlign={'center'} color={colors.dark}>Sur Google avec plus de 2000 avis</Stack>
                        </Grid>
                        <Grid item md={4} xs={12} px={4}>
                            <Stack className='century-bold' fontSize={40} textAlign={'center'} color={colors.pink} pb="16px">9500 €</Stack>
                            <Stack fontSize={18} textAlign={'center'} color={colors.dark}>D'économie moyenne</Stack>
                        </Grid>
                    </Grid>
                </Stack>
                <Grid container justifyContent={"center"} mt={8} pb={{ md: 0, xs: 4 }}>
                    <Button onClick={() => navigate("/", { replace: true })} startIcon={<BsArrowLeft />} className="btn-decouvrir-pink" variant="contained">
                        Page d'accueil
                    </Button>
                </Grid>
            </CustomContainer>
        </div>
    );
};
